import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { requestPasswordReset } from '../../api/BackendApi.jsx';
import { AuthLayout, FormInput, FormButton } from '../../components/AuthComponents.jsx';

const ForgotPasswordPage = () => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [cooldown, setCooldown] = useState(0);

    // Timer effect: decrements cooldown every second
    useEffect(() => {
        let timer = null;
        if (cooldown > 0) {
            timer = setInterval(() => {
                setCooldown((prev) => prev - 1);
            }, 1000);
        }
        return () => {
            if (timer) clearInterval(timer);
        };
    }, [cooldown]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        if (cooldown > 0) {
            return;
        }

        setIsLoading(true);

        try {
            const response = await requestPasswordReset({ email });
            setSuccess(response.message || 'Password reset email sent. Please check your inbox.');
        } catch (err) {
            if (err.remaining_seconds) {
                setCooldown(err.remaining_seconds);
                setError(`Pro znovuodeslání emailu počkejte ${err.remaining_seconds} sekund.`);
            } else {
                setError(err.message || 'Nepodařilo se odeslat email. Zkuste to prosím znovu.');
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
    <AuthLayout title="Zapomněli jste heslo?">
        <form className="space-y-6" onSubmit={handleSubmit}>
            <p className="text-sm text-center text-gray-600">
                Zadejte emailovou adresu. Pošleme vám zprávu s odkazem na obnovení.
            </p>
            {error && (
                <div className="p-3 text-sm text-red-700 bg-red-100 rounded-md">
                {error}
                </div>
            )}
            {success && (
                <div className="p-3 text-sm text-green-700 bg-green-100 rounded-md">
                {success}
                </div>
            )}
            <FormInput
                id="email"
                label="Eamilová adresa"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
            />
            <FormButton 
                isLoading={isLoading}
                disabled={cooldown > 0} // Apply grey style and disable click
            >
                {cooldown > 0 
                    ? `Zkuste znovu za ${cooldown} sekund` 
                    : 'Odeslat zprávu'}
            </FormButton>
        </form>

        <p className="text-sm text-center text-gray-600">
        Vzpomněli jste si?{' '}
        <Link
            to="/login"
            className="font-medium text-indigo-600 hover:text-indigo-500"
        >
            Zpět na přihlášení
        </Link>
        </p>
    </AuthLayout>
    );
};

export default ForgotPasswordPage;
    


